import { formatLocalDate } from '@/shared/lib/time-utils';

export function getSessionDays(sessions: { date: string }[]): Set<string> {
    return new Set(sessions.map((session) => formatLocalDate(new Date(session.date))));
}
